import { getListUsersByFilters } from 'api/user/user.api';

export async function fetchAndSetUser(createdBy: string | null, setStep6Data: (data: any) => void) {
    if (!createdBy) return;

    const res: any = await getListUsersByFilters({ limit: '1', uuid: createdBy });
    const user = res?.data?.[0];
    setStep6Data({
        responsibleName: user?.name || '',
        responsibleRole: user?.position || user?.occupation || '',
        responsibleContact: user?.contactList?.[0]?.value || '',
    });
}
